module.exports = __webpack_public_path__ + "5afa937efbdbaf767af7c6472ecb2546.jpg";